import { Model } from 'modules/core/lib/mobx-rest'

export interface INotifier {
  id: string
  slug: string
  title: string
  triggers: string[]
}

class Notifier extends Model<INotifier> {
  static urlRoot() {
    return '/automations/notifiers'
  }

  static Slugs = {
    documentCreated: 'DOCUMENT_CREATED',
    employeeCreated: 'EMPLOYEE_CREATED',
    employeeTerminated: 'EMPLOYEE_TERMINATED',
    employeeUpdated: 'EMPLOYEE_UPDATED',
    reviewRequestCompleted: 'REVIEW_REQUEST_COMPLETED',
    leaveCreated: 'LEAVE_CREATED',
    leaveUpdated: 'LEAVE_UPDATED',
  }
}

export default Notifier
